import PlusIcon from "../../icons/plus.svg"
import PlayerReasonsToPlay from "./PlayerReasonsToPlay";

const style = {
	main: "relative",
	icon: {
		plusContainer: "m-auto p-[3px] size-fit border-2 text-center rounded-full cursor-pointer",
		plus: "w-[12px]"
	},
	setContainer: "m-3 flex flex-row flex-wrap justify-between gap-3",
	header: "mb-2 mt-1 text-2xl font-bold text-center text-gray-800",
	reasonContainer:
		"m-1 p-2 w-96 h-fit flex flex-col justify-between border border-gray-400 text-center shadow rounded-lg hover:bg-gray-200",
};

function ReasonsToPlay(props) {
	return (
		<div>
			<h2 className={style.header}>Reasons-2-Play (R2P)</h2>
			<div aria-label="Add Reason" className={style.icon.plusContainer} onClick={props.openEditReasonModal}>
				<PlusIcon className={style.icon.plus} />
			</div>
			<div className={style.setContainer}>
				{props.reasonsToPlay.map(reasonToPlay => (
					<PlayerReasonsToPlay
						key={reasonToPlay.id}
						role={props.role}
						playerId={props.playerId}
						reasonToPlay={reasonToPlay}
						updateReasonPriorities={props.updateReasonPriorities}
						openEditReasonForm={props.openEditReasonForm}
						openEditReasonModal={props.openEditReasonModal}
						openConfirmActionModal={props.openConfirmActionModal}
					/>
				))}
			</div>
		</div>
	);
}

export default ReasonsToPlay;
